<template>
  <path
    d="M20 16.0002H22V14.0002H20V16.0002ZM20 8.00024V11.0002C20 11.5502 20.45 12.0002 21 12.0002C21.55 12.0002 22 11.5502 22 11.0002V8.00024C22 7.45024 21.55 7.00024 21 7.00024C20.45 7.00024 20 7.45024 20 8.00024ZM10 4.00024C5.58 4.00024 2 7.58024 2 12.0002C2 16.4202 5.58 20.0002 10 20.0002C14.42 20.0002 18 16.4202 18 12.0002C18 7.58024 14.42 4.00024 10 4.00024ZM10 14.0002C8.9 14.0002 8 13.1002 8 12.0002C8 10.9002 8.9 10.0002 10 10.0002C11.1 10.0002 12 10.9002 12 12.0002C12 13.1002 11.1 14.0002 10 14.0002Z"
  />
</template>
